import type { PaginationPanel } from 'ag-grid-community';

// read-only current page: the default page input widens the panel and shifts the row summary
export const PAGINATION_PANELS: PaginationPanel[] = [
  'pageSize',
  'rowSummary',
  { type: 'pageSummary', suppressPageInput: true },
];
